import container from './awilix-container';
import AppBloc from './blocs/app.bloc';
import AppBarBloc from './blocs/appBar.bloc';
import CaseDetailsBloc from './blocs/caseDetails.bloc';
import CasesBloc from './blocs/cases.bloc';
import ConfirmTokenBloc from './blocs/confirmToken.bloc';
import CreateCaseBloc from './blocs/createCase.bloc';
import CreatePasswordBloc from './blocs/createPassword.bloc';
import CreateWorkSpaceBloc from './blocs/createWorkSpace.bloc';
import CreatorDashboardBloc from './blocs/creatorDashboard.bloc';
import CreatorsBloc from './blocs/creators.bloc';
import DialogBloc from './blocs/dialog.bloc';
import DiscountsBloc from './blocs/discounts.bloc';
import DowngradeBloc from './blocs/downgrade.bloc';
import DownloadBloc from './blocs/download.bloc';
import DrawerBloc from './blocs/drawer.bloc';
import EditWorkspaceBloc from './blocs/editworkspace.bloc';
import EmailChangeBloc from './blocs/emailChange.bloc';
import LoginBloc from './blocs/login.bloc';
import MyAccountBloc from './blocs/myAccount.bloc';
import NotificationsBloc from './blocs/notifications.bloc';
import OrderList from './blocs/order-list.bloc';
import PatientAccountBloc from './blocs/patientAccount.bloc';
import PatientDashboardBloc from './blocs/patientDashboard.bloc';
import PatientListBloc from './blocs/patientList.bloc';
import PatientReportBloc from './blocs/patientReport.bloc';
import PaymentBloc from './blocs/payment.bloc';
import PaymentRedirectResultBloc from './blocs/paymentRedirectResult.bloc';
import PersonalizedVideoReportBloc from './blocs/personalizedVideoReport.bloc';
import RegisterBloc from './blocs/register.bloc';
import ReportViewerBloc from './blocs/report-viewer.bloc';
import ResendInviteBloc from './blocs/resendInvite.bloc';
import ResourcesBloc from './blocs/resources.bloc';
import SelfHelpMaterialsBloc from './blocs/selfHelpMaterials.bloc';
import ShareLinkBloc from './blocs/share-link.bloc';
import SnackbarAppBloc from './blocs/snackbarApp.bloc';
import TemplateDetailsBloc from './blocs/templateDetails.bloc';
import TemplatesBloc from './blocs/templates.bloc';
import UpgradePlanBloc from './blocs/upgradePlan.bloc';
import UploadProgressBloc from './blocs/upload-progress.bloc';
import VideoReportBloc from './blocs/videoReport.bloc';
import VideoRequestBloc from './blocs/videoRequest.bloc';
import ViewerBloc from './blocs/viewer.bloc';
import WorkspacesBloc from './blocs/workspaces.bloc';
import AdminRepository from './repositories/admin.repository';
import AmbraNamespaceRepository from './repositories/ambra-namespace.repository';
import AppRepository from './repositories/app.repository';
import AuthRepository from './repositories/auth.repository';
import CasesRepository from './repositories/cases.repository';
import ConfirmTokenRepository from './repositories/confirmToken.repository';
import CreatorRepository from './repositories/creator.repository';
import DialogRepository from './repositories/dialog.repository';
import DiscountsRepository from './repositories/discounts.repository';
import DrawerRepository from './repositories/drawer.repository';
import EmailChangeRepository from './repositories/emailChange.repository';
import ErrorRepository from './repositories/error.repository';
import MaterialRepository from './repositories/material.repository';
import NotificationsRepository from './repositories/notifications.repository';
import OrderTrackingRepository from './repositories/order-tracking.repository';
import PatientRepository from './repositories/patient.repository';
import PaymentRepository from './repositories/payment.repository';
import ResourceRepository from './repositories/resource.repository';
import SelfHelpCategoryRepository from './repositories/self-help-category.repository';
import TemplateRepository from './repositories/template.repository';
import UploadProgressRepository from './repositories/upload-progress.repository';
import UserRepository from './repositories/user.repository';
import WorkspaceRepository from './repositories/workspace.repository';
import AdminService from './services/admin.service';
import AmbraNamespaceService from './services/ambra-namespace.service';
import AuthService from './services/auth.service';
import CasesService from './services/cases.service';
import ConfirmTokenService from './services/confirm-token.service';
import CreatorService from './services/creator.service';
import DiscountsService from './services/discounts.service';
import FreshchatService from './services/freshchat.service';
import MaterialService from './services/material.service';
import NotificationsService from './services/notifications.service';
import OrderTrackingService from './services/order-tracking.service';
import PatientService from './services/patient.service';
import PaymentService from './services/payment.service';
import ResourceService from './services/resource.service';
import SelfHelpCategoryService from './services/self-help-category.service';
import SocketService from './services/socket.service';
import TemplateService from './services/template.service';
import TokenAuthService from './services/token-auth.service';
import UserService from './services/user.service';
import WorkspaceService from './services/workspace.service';

const awilix = require('awilix');

container.register({
  appBarBloc: awilix.asClass(AppBarBloc),
  appBloc: awilix.asClass(AppBloc),
  caseDetailsBloc: awilix.asClass(CaseDetailsBloc),
  casesBloc: awilix.asClass(CasesBloc),
  confirmTokenBloc: awilix.asClass(ConfirmTokenBloc),
  createCaseBloc: awilix.asClass(CreateCaseBloc),
  createPasswordBloc: awilix.asClass(CreatePasswordBloc),
  createWorkspaceBloc: awilix.asClass(CreateWorkSpaceBloc),
  creatorDashboardBloc: awilix.asClass(CreatorDashboardBloc),
  creatorsBloc: awilix.asClass(CreatorsBloc),
  dialogBloc: awilix.asClass(DialogBloc),
  discountsBloc: awilix.asClass(DiscountsBloc),
  downgradeBloc: awilix.asClass(DowngradeBloc),
  downloadBloc: awilix.asClass(DownloadBloc),
  drawerBloc: awilix.asClass(DrawerBloc),
  editWorkspaceBloc: awilix.asClass(EditWorkspaceBloc),
  emailChangeBloc: awilix.asClass(EmailChangeBloc),
  loginBloc: awilix.asClass(LoginBloc),
  myAccountBloc: awilix.asClass(MyAccountBloc),
  notificationsBloc: awilix.asClass(NotificationsBloc),
  orderListBloc: awilix.asClass(OrderList),
  patientAccountBloc: awilix.asClass(PatientAccountBloc),
  patientDashboardBloc: awilix.asClass(PatientDashboardBloc),
  patientListBloc: awilix.asClass(PatientListBloc),
  patientReportBloc: awilix.asClass(PatientReportBloc),
  paymentBloc: awilix.asClass(PaymentBloc),
  paymentRedirectResultBloc: awilix.asClass(PaymentRedirectResultBloc),
  personalizedVideoReportBloc: awilix.asClass(PersonalizedVideoReportBloc),
  registerBloc: awilix.asClass(RegisterBloc),
  reportViewerBloc: awilix.asClass(ReportViewerBloc),
  resendInviteBloc: awilix.asClass(ResendInviteBloc),
  resourcesBloc: awilix.asClass(ResourcesBloc),
  selfHelpMaterialsBloc: awilix.asClass(SelfHelpMaterialsBloc),
  shareLinkBloc: awilix.asClass(ShareLinkBloc),
  snackbarAppBloc: awilix.asClass(SnackbarAppBloc),
  templateDetailsBloc: awilix.asClass(TemplateDetailsBloc),
  templatesBloc: awilix.asClass(TemplatesBloc),
  upgradePlanBloc: awilix.asClass(UpgradePlanBloc),
  uploadProgressBloc: awilix.asClass(UploadProgressBloc),
  videoReportBloc: awilix.asClass(VideoReportBloc),
  videoRequestBloc: awilix.asClass(VideoRequestBloc),
  viewerBloc: awilix.asClass(ViewerBloc),
  workspacesBloc: awilix.asClass(WorkspacesBloc),
});

container.register({
  adminRepository: awilix.asClass(AdminRepository).singleton(),
  ambraNamespaceRepository: awilix.asClass(AmbraNamespaceRepository).singleton(),
  appRepository: awilix.asClass(AppRepository).singleton(),
  authRepository: awilix.asClass(AuthRepository).singleton(),
  casesRepository: awilix.asClass(CasesRepository).singleton(),
  confirmTokenRepository: awilix.asClass(ConfirmTokenRepository).singleton(),
  creatorRepository: awilix.asClass(CreatorRepository).singleton(),
  dialogRepository: awilix.asClass(DialogRepository).singleton(),
  discountsRepository: awilix.asClass(DiscountsRepository).singleton(),
  drawerRepository: awilix.asClass(DrawerRepository).singleton(),
  emailChangeRepository: awilix.asClass(EmailChangeRepository).singleton(),
  errorRepository: awilix.asClass(ErrorRepository).singleton(),
  materialRepository: awilix.asClass(MaterialRepository).singleton(),
  notificationsRepository: awilix.asClass(NotificationsRepository).singleton(),
  orderTrackingRepository: awilix.asClass(OrderTrackingRepository).singleton(),
  patientRepository: awilix.asClass(PatientRepository).singleton(),
  paymentRepository: awilix.asClass(PaymentRepository).singleton(),
  resourceRepository: awilix.asClass(ResourceRepository).singleton(),
  selfHelpCategoryRepository: awilix.asClass(SelfHelpCategoryRepository).singleton(),
  templateRepository: awilix.asClass(TemplateRepository).singleton(),
  uploadProgressRepository: awilix.asClass(UploadProgressRepository).singleton(),
  userRepository: awilix.asClass(UserRepository).singleton(),
  workspaceRepository: awilix.asClass(WorkspaceRepository).singleton(),
});

container.register({
  adminService: awilix.asClass(AdminService).singleton(),
  ambraNamespaceService: awilix.asClass(AmbraNamespaceService).singleton(),
  authService: awilix.asClass(AuthService).singleton(),
  casesService: awilix.asClass(CasesService).singleton(),
  confirmTokenService: awilix.asClass(ConfirmTokenService).singleton(),
  creatorService: awilix.asClass(CreatorService).singleton(),
  discountsService: awilix.asClass(DiscountsService).singleton(),
  freshchatService: awilix.asClass(FreshchatService).singleton(),
  materialService: awilix.asClass(MaterialService).singleton(),
  notificationsService: awilix.asClass(NotificationsService).singleton(),
  orderTrackingService: awilix.asClass(OrderTrackingService).singleton(),
  patientService: awilix.asClass(PatientService).singleton(),
  paymentService: awilix.asClass(PaymentService).singleton(),
  resourceService: awilix.asClass(ResourceService).singleton(),
  selfHelpCategoryService: awilix.asClass(SelfHelpCategoryService).singleton(),
  socketService: awilix.asClass(SocketService).singleton(),
  templateService: awilix.asClass(TemplateService).singleton(),
  tokenAuthService: awilix.asClass(TokenAuthService).singleton(),
  userService: awilix.asClass(UserService).singleton(),
  workspaceService: awilix.asClass(WorkspaceService).singleton(),
});

export default container;
